import { DocumentReference } from "@angular/fire/compat/firestore";

export class UserModel {

    public id?: string;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public companyEmail?: string;
    public lang?: string;
    public birthday?: string;
    public default?: boolean;
    public roles?: any[] = [];
    public status?: string;
    public emailVerified?: any;
    public copExpired?: boolean;
    public phone?: string;
    public lastConsultancyProcessFinishedDate: any;

    constructor(id?: string, firstName?: string, lastName?: string, email?: string, lang?: string, roles?: any[], copExpired?: boolean) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.lang = lang;
        this.roles = roles ? roles : [];
        this.copExpired = copExpired;
    }

}

export class LoggedInUser {
    public id?: string;
    public email?: string;
    public companyId?: string;
    public companyEmail?: string;
    public firstName?: string;
    public lastName?: string;
    public lang?: string;
    public finsteinHelper?: boolean;
    public finsteinHelperType?: string;
    public birthday?: string;
    public roles?: any[] = [];
    public status?: string;
    public emailVerified?: any;
    public copExpired?: boolean;
    public phone?: string;
    public lastConsultancyProcessRef?: DocumentReference;
    public consultancyProcessAlreadyFinished?: boolean;
}
